import React, { FC, useState, useEffect, createRef } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Paper, Divider } from '@material-ui/core';
import Typo from '../../../Components/Typo';
import gsap from 'gsap';
import { THEME_PALETTE, GRADIENTS } from '../../../Theme/themeValues';
import StyledLabel from '../../../Components/StyledLabel';
import ContrastText from '../../../Components/ContrastText';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import InteractiveSessions from './ExperienceContent/InteractiveSessions';
import Meetings from './ExperienceContent/Meetings';
import Networking from './ExperienceContent/Networking';
import Chat from './ExperienceContent/Chat';
import { EXPERIENCES_CONTAINER_WIDTH } from '..';
import Rewards from './ExperienceContent/Rewards';
import OnDemandVideo from './ExperienceContent/OnDemandVideo';
import LOUDSPEAKER_IMAGE from '../../../Assets/images/loudspeaker.svg';
import { useMediaQuery } from '../../../Hooks/useMediaQuery';


export interface ExperiencesProps {

}

const Experiences: FC<ExperiencesProps> = (props) => {
    const classes = useStyles();
    const { isDeviceSm } = useMediaQuery();
    const [selected, setSelected] = useState(0);
    const labelsContainerRef = createRef<HTMLDivElement>();
    const id = uniqueId('experience-screen');
    // const calcPos = gsap.utils.mapRange()

    const CONFIG = [
        { label: 'Interactive<br/>Live Sessions', content: <InteractiveSessions /> },
        { label: 'Meetings With<br/>Your Experts', content: <Meetings /> },
        { label: 'Networking With<br/>Other Attendees', content: <Networking /> },
        { label: 'Videos And Downloads<br/>On Demand', content: <OnDemandVideo /> },
        { label: 'Gamification And<br/>Rewards', content: <Rewards /> },
        { label: 'Chats', content: <Chat /> },
    ]

    const getSectionId = (i: number) => `${id}-section-${i}`;

    const handleMouseEnter = (i: number) => (e: React.MouseEvent<HTMLDivElement>) => {
        const highlighter = `.${classes.highlight}`;
        const id = getSectionId(i);
        console.log("mouse enter", i, e)
        gsap.to(highlighter, {

        })
    }


    const handleClick = (i: number) => (e: React.MouseEvent<HTMLDivElement>) => {
        gsap.timeline()
            .to(`#${id}-content`, {
                opacity: 0, onComplete: () => {
                    setSelected(i);
                }, ease: 'power2.easeIn'
            })
            .to(`#${id}-content`, { opacity: 1 })
        // setSelected(i);
    }

    useEffect(() => {
        // gsap.to(`#${id}-content`, {
        //     scrollTrigger: {
        //         trigger: `#${id}`,
        //         scrub: 1,
        //         toggleActions: 'restart pause'
        //     },
        //     y: -40,
        // })
    }, [])




    return (
        <section>
            <Box id={id} display='flex' mt={20} flexDirection='column'>
                <img className={classes.loudspeakerImage} src={LOUDSPEAKER_IMAGE} alt='Loudspeaker' />
                <StyledLabel
                    variant="h3"
                    weight='medium'
                    containerClass={classes.sectionTitleContainer}
                    text='Give your attendees a personalised, interactive event experience'
                />
                {isDeviceSm ? (
                    <Box display='flex' width='100%' mt={11} alignItems='center' flexDirection='column'>
                        {CONFIG.map((c, i) => (
                            <Box mb={5} id={getSectionId(i)} key={c.label}>
                                <Typo variant='h4' gutterBottom lineHeight={1.2} color='inherit' weight='medium' dangerouslySetInnerHTML={{ __html: c.label }} />
                                {c.content}
                            </Box>
                        ))}

                    </Box>
                ) : (
                    <Box display='flex' width='100%' mt={11} alignItems='center' height="450px">
                        <div ref={labelsContainerRef} className={classes.labelsContainer} >
                            {CONFIG.map((c, i) => (
                                <div id={getSectionId(i)} key={c.label} onClick={handleClick(i)} className={clsx(classes.section, { [classes.selected]: i === selected })}>
                                    <Typo lineHeight={1.2} color='inherit' weight='medium' dangerouslySetInnerHTML={{ __html: c.label }} />
                                </div>
                            ))}
                            {/* <div className={classes.highlight} /> */}
                        </div>
                        <Box id={`${id}-content`} flex={1} height={getHeight() + 'px'} >
                            {CONFIG[selected].content}
                        </Box>
                    </Box>
                )}
            </Box>
        </section>
    )
}


function getHeight() {
    // aspect ration => 16:9
    const width = EXPERIENCES_CONTAINER_WIDTH - LABELS_CONTAINER_WIDTH;
    return 9 / 16 * width
}
// 16:9
const LABELS_CONTAINER_WIDTH = 280;
const useStyles = makeStyles<Theme, any>((theme) => ({
    sectionTitleContainer: {
        position: 'relative',
        width: 800,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100vw - 32px)',
            marginLeft: 0,

        }
    },

    labelsContainer: {
        display: 'flex',
        width: LABELS_CONTAINER_WIDTH,
        flexDirection: 'column',
        // height: '100%'
    },
    section: {
        position: 'relative',
        cursor: 'pointer',
        height: 70,
        color: theme.palette.text.primary,
        width: 240,
        padding: '0px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        borderBottom: `2px solid white`,
        '&:last-child': {
            border: 'none'
        }
    },
    selected: {
        height: 70,
        width: 240,
        // zIndex: ,
        // position: 'absolute',
        background: GRADIENTS[1],
        borderRadius: 4,
        boxShadow: theme.shadows[1],
        color: theme.palette.common.white,
        border: 'none',
        position: 'relative',
        '&:after': {
            content: "' '",
            position: 'absolute',
            right: -6,
            zIndex: -1,
            top: `calc(50% - 10px)`,
            transform: 'rotate(45deg)',
            width: 20,
            height: 20,
            background: theme.palette.primary.main
        }
    },
    highlight: {
        height: 70,
        width: 240,
        left: 0,
        zIndex: -1,
        position: 'absolute',
        background: GRADIENTS[1],
        borderRadius: 4,
        boxShadow: theme.shadows[1],
        color: theme.palette.common.white
    },
    loudspeakerImage: {
        width: 80,
        height: 80,
        margin: theme.spacing(-3, -4),
        [theme.breakpoints.down('sm')]: {
            margin: 0
        }
    }
}));

export default Experiences;